import { useEffect } from 'react'
import type { ErrorComponentProps } from '@tanstack/react-router'

import { errorReporter } from '@/lib/errorReporter'
import { ErrorFallback } from './ErrorFallback'

function reportRouteError(error: unknown) {
  if (!error) return

  let errorMessage = 'Unknown route error'
  let errorStack = ''

  if (error instanceof Error) {
    errorMessage = error.message
    errorStack = error.stack || ''
  } else if (typeof error === 'string') {
    errorMessage = error
  } else {
    try {
      errorMessage = JSON.stringify(error)
    } catch {
      errorMessage = String(error)
    }
  }

  errorReporter.report({
    message: errorMessage,
    stack: errorStack,
    url: window.location.href,
    timestamp: new Date().toISOString(),
    source: 'tanstack-router',
    error,
    level: 'error',
  })
}

export function RouteErrorBoundary({ error }: ErrorComponentProps) {
  useEffect(() => {
    reportRouteError(error)
  }, [error])

  return (
    <ErrorFallback
      title="Unexpected Error"
      message="An unexpected error occurred while loading this page."
      error={error}
      statusMessage="Routing error detected"
    />
  )
}
